import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { SessionService } from '../auth/session-service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const sessionService = inject(SessionService);

  const excludedEndpoints = ['/login'];

  const isExcluded = excludedEndpoints.some((endpoint) => req.url.includes(endpoint));

  if (isExcluded) {
    return next(req);
  }

  const token = sessionService.getToken();

  if (!token) {
    return next(req);
  }

  const authRequest = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
    },
  });

  return next(authRequest);
};
